module.exports = __webpack_public_path__ + "img/joinus_stimulate@2x.e5c702f1.png";